import { Link, useLocation } from 'react-router-dom'
import { Globe, LayoutDashboard, FileText, Briefcase, Settings } from 'lucide-react'
import { useAuth } from '../hooks/useAuth'

const links = [
  { to: '/admin/dashboard', label: 'Dashboard', icon: LayoutDashboard },
  { to: '/admin/blog', label: 'Blog', icon: FileText },
  { to: '/admin/cases', label: 'Cases', icon: Briefcase },
  { to: '/admin/settings', label: 'Configurações', icon: Settings },
]

export default function TopBar() {
  const { user } = useAuth()
  const location = useLocation()

  const active = (path) => location.pathname.startsWith(path)

  return (
    <header
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 50,
        padding: '14px 24px',
        background: 'linear-gradient(135deg, #101b13 0%, #152419 100%)',
        borderBottom: '1px solid rgba(190,241,2,0.08)',
        boxShadow: '0 10px 30px rgba(9, 15, 11, 0.24)',
      }}
    >
      <div
        style={{
          maxWidth: '1400px',
          margin: '0 auto',
          display: 'grid',
          gridTemplateColumns: 'auto 1fr auto',
          alignItems: 'center',
          gap: '20px',
        }}
      >
        <Link
          to="/"
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '10px',
            textDecoration: 'none',
            color: '#dbe4db',
            fontSize: '14px',
            fontWeight: 600,
          }}
        >
          <div
            style={{
              width: '34px',
              height: '34px',
              borderRadius: '10px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: 'rgba(190,241,2,0.14)',
              color: '#bef102',
            }}
          >
            <Globe size={18} />
          </div>
          <span>Ver site</span>
        </Link>

        <nav
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '14px',
            flexWrap: 'wrap',
          }}
        >
          {links.map((link) => {
            const Icon = link.icon
            const isActive = active(link.to)

            return (
              <Link
                key={link.to}
                to={link.to}
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '10px',
                  minWidth: '150px',
                  justifyContent: 'center',
                  padding: '12px 18px',
                  borderRadius: '16px',
                  textDecoration: 'none',
                  backgroundColor: isActive ? '#eef9ef' : 'transparent',
                  color: isActive ? '#0d1f12' : '#9ba8a0',
                  border: isActive ? '1px solid rgba(190,241,2,0.35)' : '1px solid transparent',
                  boxShadow: isActive ? '0 10px 24px rgba(10, 17, 12, 0.18)' : 'none',
                  fontSize: '15px',
                  fontWeight: 700,
                  transition: 'all 0.2s ease',
                }}
              >
                <Icon size={18} />
                <span>{link.label}</span>
              </Link>
            )
          })}
        </nav>

        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            justifySelf: 'end',
          }}
        >
          <div style={{ textAlign: 'right' }}>
            <div style={{ fontSize: '11px', color: '#7f8f85', textTransform: 'uppercase', letterSpacing: '0.08em' }}>
              Admin
            </div>
            <div style={{ fontSize: '13px', color: '#f0f4f0', fontWeight: 700 }}>
              {user?.email || 'conta@orken.com'}
            </div>
          </div>
          <div
            style={{
              width: '42px',
              height: '42px',
              borderRadius: '14px',
              backgroundColor: '#bef102',
              color: '#0d1f12',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontWeight: 800,
              fontSize: '16px',
            }}
          >
            {user?.email?.charAt(0).toUpperCase() || 'A'}
          </div>
        </div>
      </div>
    </header>
  )
}
